import type { ImageStore, PromoWithFormat, Translations } from '@ps-int/promozavr/app/api/types';

export const PROMOZAVR_PROJECT = 'telemostDesktop';
export const PROMOZAVR_STAGE = 'page-init';
export const PROMOZAVR_MODEL = 'promozavr/select-promo';
export const FETCH_YOURSELF = 'fetch_yourself';

export type PromozavrRendererSource = 'local' | 'remote';
export type PromozavrStatus = 'idle' | 'loading' | 'success' | 'error';

export type SelectPromoSuppliersData = {
    bunkerConfigSupplierData: typeof FETCH_YOURSELF;
    billingDataSupplierData: typeof FETCH_YOURSELF;
    billingSubscriptionsDataSupplierData: typeof FETCH_YOURSELF;
    blackboxUserInfoSupplierData: typeof FETCH_YOURSELF;
    datasyncPromoDataSupplierData: typeof FETCH_YOURSELF;
    datasyncUserFeaturesSupplierData: typeof FETCH_YOURSELF;
    saasKvSegmentsSupplierData: typeof FETCH_YOURSELF;
};

export type PromozavrQueryParams = {
    app?: string;
    debug?: string;
    debugParams?: string;
};

export type SelectPromoModelInput = PromozavrQueryParams & {
    project: typeof PROMOZAVR_PROJECT;
    stage: typeof PROMOZAVR_STAGE;
    lang?: string;
    tld?: string;
    testIds: string[];
    skipPromos: string[];
    selectAllPromos: false;
    usePersistentQueues: false;
    suppliersData: SelectPromoSuppliersData;
};

export type SelectPromoModelServerInput = SelectPromoModelInput & {
    fastFail?: boolean;
};

export type SelectPromoModelResponse = {
    selectedPromos?: PromoWithFormat[];
    translations?: Translations;
    images?: ImageStore;
    isSelected: boolean;
};

export type PromozavrState = {
    status: PromozavrStatus;
    request?: SelectPromoModelServerInput;
    requestKey?: string;
    selectedPromo?: PromoWithFormat;
    translations?: Translations;
    images?: ImageStore;
    isSelected: boolean;
    rendererSource: PromozavrRendererSource;
    lastError?: string;
};
